import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SensorFilterComponent } from './sensor-filter/sensor-filter.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    SensorFilterComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule
  ]
})
export class SensorModule { }
